import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { paymentsApi, type PaymentStatus } from '@/api/payments-api';

const PAYMENTS_KEY = 'payments';

export function usePayments(params?: { patientId?: string; doctorId?: string; page?: number; limit?: number }) {
  return useQuery({
    queryKey: [PAYMENTS_KEY, params],
    queryFn: () => paymentsApi.getPayments(params || {}),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    retry: 2,
  });
}

export function usePayment(paymentId: string) {
  return useQuery({
    queryKey: [PAYMENTS_KEY, paymentId],
    queryFn: () => paymentsApi.getPaymentStatus(paymentId),
    enabled: !!paymentId,
    staleTime: 1000 * 30,
    gcTime: 1000 * 60 * 5,
    retry: 2,
  });
}

export function useRefundPayment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ paymentId, amount }: { paymentId: string; amount?: number }) =>
      paymentsApi.refundPayment(paymentId, amount),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [PAYMENTS_KEY] });
      queryClient.setQueryData([PAYMENTS_KEY, data.paymentId], (old: unknown) => {
        if (!old) return old;
        return { ...(old as object), status: 'REFUNDED' } as PaymentStatus;
      });
    },
  });
}
